import { useRef, useState, ComponentProps, FC } from 'react'

import Button from 'components/display/Button'
import CrossOutIcon from 'components/icons/CrossOut'

import MuxPlayer, { MuxPlayerHandle } from '../display/MuxPlayer'

import {
  CloseButton,
  FullScreenVideo,
  FullScreenVideoHeader,
} from './VideoBanner'
import { ABOUT_RIPARIDE_PLAYBACK_ID } from './videoPlaybackIds'

type Props = {
  playbackId?: string
} & Omit<ComponentProps<typeof Button>, 'onClick'>

const VideoButton: FC<Props> = ({ playbackId, children, ...props }) => {
  const [open, setOpen] = useState(false)
  const [playing, setPlaying] = useState(false)

  const videoRef = useRef<MuxPlayerHandle>(null)

  const handlePlayVideo = () => {
    setOpen(true)
    setTimeout(() => {
      setPlaying(true)
      videoRef.current?.play()
    }, 200)
  }

  const handleClose = () => {
    setPlaying(false)
    videoRef.current?.pause()
    setTimeout(() => {
      setOpen(false)
    }, 200)
  }

  return (
    <div style={{ position: 'relative' }}>
      {open && (
        // @ts-ignore
        <FullScreenVideo playing={playing}>
          <FullScreenVideoHeader>
            <CloseButton onClick={handleClose}>
              <CrossOutIcon />
            </CloseButton>
          </FullScreenVideoHeader>
          <MuxPlayer
            ref={videoRef}
            playbackId={playbackId || ABOUT_RIPARIDE_PLAYBACK_ID}
          />
        </FullScreenVideo>
      )}
      <Button uppercase={false} ghost {...props} onClick={handlePlayVideo}>
        {children}
      </Button>
    </div>
  )
}

export default VideoButton
